var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "video-unmute-overlay stick-all-corners",
      on: {
        click: _vm.handleClick,
        mousedown: function() {
          return (_vm.active = true)
        },
        mouseup: function() {
          return (_vm.active = false)
        },
        mouseover: function() {
          return (_vm.hover = true)
        },
        mouseout: function() {
          return (_vm.hover = false)
        },
        touchstart: function() {
          return (_vm.touch = true)
        },
        touchend: function() {
          return (_vm.touch = false)
        },
        focus: function() {
          return (_vm.focus = true)
        },
        blur: function() {
          return (_vm.focus = false)
        }
      }
    },
    [
      _c(
        "VideoInPlayerOverlayButton",
        {
          staticClass: "unmute-button",
          attrs: {
            alignment: "left",
            focus: _vm.active || _vm.hover || _vm.focus || _vm.touch
          }
        },
        [
          _c("VsIcon", { attrs: { icon: "md:volume_off" } }),
          _vm._v(" "),
          _c("span", { staticClass: "hint" }, [
            _vm._v(_vm._s(_vm.$t("unmute")))
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }